import { useNode } from "@craftjs/core";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";

import { getRecordingById } from "@/content-hub/store/selectors";

import { applyLibraryRecordingToVideoBlock } from "../recording-metadata-merge";
import type { VideoBlockProps } from "../video";
import { AdvancedSettings } from "./advanced-settings";
import { RecordingLibraryPicker } from "./recording-library-picker";

export const LibrarySetting = () => {
  const {
    props,
    actions: { setProp },
  } = useNode((query) => ({
    props: query.props as VideoBlockProps,
  }));

  const flags = useFlags();
  const directVideoSharingEnabled = Boolean(flags.contentHubDirectVideoSharing);
  const recording = useSelector(getRecordingById(props.recordingId));

  return (
    <div className="flex flex-col gap-y-4 p-4">
      <RecordingLibraryPicker
        recordingId={props.recordingId}
        recording={recording}
        showPreviewThumbnail={!directVideoSharingEnabled}
        onRecordingSelected={(nextRecordingId) => {
          setProp((blockProps: VideoBlockProps) => {
            if (directVideoSharingEnabled) {
              applyLibraryRecordingToVideoBlock(blockProps, nextRecordingId);
            } else {
              blockProps.url = null;
              blockProps.recordingId = nextRecordingId;
            }
          });
        }}
      />
      <AdvancedSettings />
    </div>
  );
};
